import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/guidances`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function workplaces (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/guidance/${id}/workplaces`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function manageShift (id) {
    let options;
    let idType = typeof(id);
    if (idType !== 'object') {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            }
        };
    } else {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            },
            params: id,
            paramsSerializer: function (params) {
                return qs.stringify(params, { encode: false });
            },
        };
        id = id.id;
    }
    return axios.post(`${url}/guidance/${id}/manage/shift`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function generateTakeon (id) {
    let options;
    let idType = typeof(id);
    if (idType !== 'object') {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            }
        };
    } else {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            },
            params: id,
            paramsSerializer: function (params) {
                return qs.stringify(params, { encode: false });
            },
        };
        id = id.id;
    }
    return axios.post(`${url}/guidance/${id}/generate/takeon`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function generateSchedule (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/schedules/${id}/generate`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}

function get (id) {
    let options;
    let idType = typeof(id);
    if (idType !== 'object') {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            }
        };
    } else {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            },
            params: id,
            paramsSerializer: function (params) {
                return qs.stringify(params, { encode: false });
            },
        };
        id = id.id;
    }
    return axios.get(`${url}/guidances/${id}`, options)

        .then(response => {
            let guidance = jsona.deserialize(response.data);
            delete guidance.links;
            return guidance;
        });
}

function view (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/guidances/${params.id}`,options)

        .then(response => {
            let guidance = jsona.deserialize(response.data);
            delete guidance.links;
            return guidance;
        });
}

function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/guidances/${id}?include=department, works`, options)
        .then(response => {
            let guidance = jsona.deserialize(response.data);
            delete guidance.links;
            return guidance;
        });
}

function add (guidance) {
    const payload = jsona.serialize({
        stuff: guidance,
        includeNames: ['departments']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/guidances?include=department`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (guidance) {
    const payload = jsona.serialize({
        stuff: guidance,
        // includeNames: ["guidanceCategory"]
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/guidances/${guidance.id}?include=department`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update1 (guidance) {
    const payload = jsona.serialize({
        stuff: guidance,
        // includeNames: ["guidanceCategory"]
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/guidance/status/${guidance.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/guidances/${id}`, options);
}

function getStatusStatistics (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/guidances/status/stats`, options)
        .then(response => {
            return response.data.data ? response.data.data : [];
        });
}



function pdfPreview (id, sections = []) {
    const options = {
        responseType: 'blob',
        headers: {
            'Accept': 'application/pdf',
        },
        params: {}
    };

    if (sections && sections.length > 0) {
        options.params.sections = sections.join(',');
    }

    return axios.get(`${url}/guidances/${id}/pdf/preview`, options)
        .then(response => {
            return response;
        })
        .catch(error => {
            console.error('PDF Preview Error:', error);
            throw error;
        });
}

function pdfRegenerate(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/guidances/${id}/pdf/regenerate`, {}, options)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.error('PDF Regenerate Error:', error);
            throw error;
        });
}

function pdfDownload (id,sections = []) {
    const options = {
        responseType: 'blob',
        headers: {
            'Accept': 'application/pdf',
        },
        params: {}
    };

    if (sections && sections.length > 0) {
        options.params.sections = sections.join(',');
    }

    return axios.get(`${url}/guidances/${id}/pdf/download`, options)
        .then(response => {
            return response;
        })
        .catch(error => {
            console.error('PDF Download Error:', error);
            throw error;
        });
}

function pdfGenerate(id) {
    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    };

    return axios.post(`${url}/guidances/${id}/pdf/generate`, {}, options)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.error('PDF Generate Error:', error);
            throw error;
        });
}
function updateAllowManual(id, allowManual) {
    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    };

    return axios.patch(
        `${url}/guidances/${id}/allow-manual`,
        {
            allow_manual: !!allowManual
        },
        options
    )
        .then(response => response.data)
        .catch(error => {
            console.error('Update Allow Manual Error:', error);
            throw error;
        });
}


export default {
    list,
    workplaces,
    manageShift,
    generateSchedule,
    generateTakeon,
    get,
    show,
    view,
    add,
    update,
    update1,
    destroy,
    getStatusStatistics,
    pdfPreview,
    pdfRegenerate,
    pdfDownload,
    pdfGenerate,
    updateAllowManual
};

